module.exports = __webpack_public_path__ + "static/img/48.5b12d9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/48.png
// module id = edcF
// module chunks = 1